export const supplierreportdata = [
  {
    id:"1",
    Reference: "INV/PO2025",
    ID: "SU001",
    Supplier: "Apex Computers",
    image:"assets/img/supplier/supplier-01.png",
    Total_Items: 10,
    Amount: "$1000",
    Payment_Method: "Cash",
    Status: "Received",
  },
  {
    id:"2",
    Reference: "INV/PO2031",
    ID: "SU002",
    Supplier: "Beats Headphones",
    image:"assets/img/supplier/supplier-02.png",
    Total_Items: 15,
    Amount: "$1500",
    Payment_Method: "Paypal",
    Status: "Pending",
  },
  {
    id:"3",
    Reference: "INV/PO2042",
    ID: "SU003",
    Supplier: "Dazzle Shoes",
    image:"assets/img/supplier/supplier-03.png",
    Total_Items: 22,
    Amount: "$1500",
    Payment_Method: "Paypal",
    Status: "Received",
  },
  {
    id:"4",
    Reference: "INV/PO2033",
    ID: "SU004",
    Supplier: "Best Accessories",
    image:"assets/img/supplier/supplier-04.png",
    Total_Items: 14,
    Amount: "$2000",
    Payment_Method: "Stripe",
    Status: "Ordered",
  },
  {
    id:"5",
    Reference: "INV/PO2042",
    ID: "SU005",
    Supplier: "A-Z Store",
    image:"assets/img/supplier/supplier-05.png",
    Total_Items: 12,
    Amount: "$800",
    Payment_Method: "Paypal",
    Status: "Received",
  },
  {
    id:"6",
    Reference: "INV/PO2011",
    ID: "SU006",
    Supplier: "Hatimi Hardwares",
    image:"assets/img/supplier/supplier-06.png",
    Total_Items: 45,
    Amount: "$750",
    Payment_Method: "Cash",
    Status: "Pending",
  },
  {
    id:"7",
    Reference: "INV/PO2014",
    ID: "SU007",
    Supplier: "Aesthetic Bags",
    image:"assets/img/supplier/supplier-07.png",
    Total_Items: 21,
    Amount: "$1300",
    Payment_Method: "Credit Card",
    Status: "Received",
  },
  {
    id:"8",
    Reference: "INV/PO2047",
    ID: "SU009",
    Supplier: "Sigma Chairs",
    image:"assets/img/supplier/supplier-09.png",
    Total_Items: 25,
    Amount: "$2300",
    Payment_Method: "Credit Card",
    Status: "Ordered",
  },
  {
    id:"9",
    Reference: "INV/PO2017",
    ID: "SU010",
    Supplier: "Zenith Bags",
    image:"assets/img/supplier/supplier-10.png",
    Total_Items: 15,
    Amount: "$1700",
    Payment_Method: "Stripe",
    Status: "Pending",
  },
];
